// extracted by mini-css-extract-plugin
module.exports = {"ware-category":"_259xTc8weZ","title-top":"_3iZjZYMXBl","title-section":"_33qsDLJtaR","table-section":"_3f4s6_DU-P","add-btn":"_1bi1RRwZqn","question-icon":"_2icS4lUmI9"};